import { Tool } from "openai/resources/responses/responses";
import { MID } from "./index.js";

//! NIEMALS DIE INDEXREIHENFOLGE DIESES ARRAY'S ÄNDERN, ANHÄNGEN IST OKAY
export const managedMcpToolNames = ["miro", "docsearcher", "ntfy", "reflactTrain"] as const;

type ManagedMCPUnion = {
  toolName: typeof managedMcpToolNames[0]
} | {
  toolName: typeof managedMcpToolNames[1],
  documentIds: string[]
} | {
  toolName: typeof managedMcpToolNames[2]
} | {
  toolName: typeof managedMcpToolNames[3],
  serverLabel: string,
  serverUrl: string,
  requiresAuth: boolean,
  accountKey?: string
};

export type ManagedMCPConfig<ID extends MID = string> =
  {
    _id: ID,
    botId: ID,
    enabled: boolean,
    type: "managed",
    toolName: typeof managedMcpToolNames[number],
    allowed_tools: string[],
    require_approval?: Tool.Mcp["require_approval"]
  }
  & ManagedMCPUnion;

export type ExternalMCPConfig<ID extends MID = string> = {
  _id: ID,
  botId: ID,
  enabled: boolean,
  type: "external",
  tool: Omit<Tool.Mcp, "allowed_tools"> & { allowed_tools: NonNullable<string[]> }
}

export type MCPConfig<ID extends MID = string> = ManagedMCPConfig<ID> | ExternalMCPConfig<ID>;

// reflactTrain ist die einzige managed-Toolart mit mehreren Instanzen pro Bot, daher serverLabel statt toolName als Schlüssel
export function getMcpInstanceKey<ID extends MID = string>(mcp: MCPConfig<ID>): string {
  if (mcp.type === "external") return mcp.tool.server_label;
  return mcp.toolName === "reflactTrain" ? mcp.serverLabel : mcp.toolName;
}